import { initialCommonState } from 'redux/initialState';
import { status } from 'constants/general';

import commonActionTypes from './action-types';

const commonReducer = (state = initialCommonState, { type, payload }) => {
  switch (type) {
    case commonActionTypes.SET_CONTEXT:
      return {
        ...state,
        context: payload,
      };

    case commonActionTypes.FETCH_STATIC_DATA:
      return {
        ...state,
        staticData: {
          status: status.FETCHING,
        },
      };

    case commonActionTypes.FETCH_STATIC_DATA_SUCCESS:
      return {
        ...state,
        staticData: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case commonActionTypes.FETCH_STATIC_DATA_FAIL:
      return {
        ...state,
        staticData: {
          status: status.FAIL,
        },
      };

    case commonActionTypes.FETCH_SEARCH_PRODUCTS: {
      return {
        ...state,
        searchProductsInfo: {
          status: status.FETCHING,
        },
      };
    }

    case commonActionTypes.FETCH_SEARCH_PRODUCTS_SUCCESS: {
      return {
        ...state,
        searchProductsInfo: {
          status: status.SUCCESS,
          details: payload,
        },
      };
    }

    case commonActionTypes.FETCH_SEARCH_PRODUCTS_FAIL: {
      return {
        ...state,
        searchProductsInfo: {
          status: status.FAIL,
        },
      };
    }

    case commonActionTypes.RESET_SEARCH_PRODUCTS: {
      return {
        ...state,
        searchProductsInfo: {
          status: status.SHOULD_CALL_API,
        },
      };
    }

    default:
      return state;
  }
};

export default commonReducer;
